import {useSuspenseQuery} from "@tanstack/react-query";

import {getUserQueryOptions} from "./get-user.query-options";

/**
 * Query hook: Fetch a single user by ID.
 * Uses suspense for cleaner component code.
 *
 * @param id - The user ID to fetch
 * @returns Query result with user data
 *
 * @example
 * const { data: user } = useGetUser(userId);
 */
export function useGetUser(id: string) {
  return useSuspenseQuery(getUserQueryOptions(id));
}
